import React, { useState, useEffect } from 'react';
import yclogo from '../../../images/Logo.png';
import '../MachineManagement.css';

import { useMachineAPI } from '../../../api/machine/useMachineAPI';

const ExpandedRow = ({ row }) => {
    const machineAPI = useMachineAPI();

    useEffect(() => {
        machineAPI.machine.status({ 
                deviceId: row.deviceId,
                ch : row.ch
            }).then(data => {
                if (data && data.length > 0) {
                    setValue(data);
                }
        });
        const id = setInterval(() => {
            machineAPI.machine.status({ 
                deviceId: row.deviceId,
                ch : row.ch
            }).then(data => {
                if (data && data.length > 0) {
                    setValue(data);
                }
            });
        }, 5000);
        return () => {
            clearInterval(id);
        };
    }, []);
    const [value, setValue] = useState(null);
    return (
        <div className="machine-expanded-row">
            <table className="machine-details-table">
                <tbody>
                    <tr>
                        <td className="machine-info-column">
                            <div className="machine-image-container">
                                <img
                                    src={row.imgUrl ? row.imgUrl : yclogo}
                                    alt={row.productName}
                                    className="machine-image"
                                />
                            </div>
                        </td>
                        <td className="machine-graph-column">
                            <div className="machine-graph-container">
                            <div>
                                <span className='circle-label'>전원</span>
                                <div className={`circle ${(Number(value) >= Number(row?.power ?? 0)) ? "power-on" : "power-off"}`}>
                                    {value >= row.power ?? 0 ? "On" : "Off"}
                                </div>
                            </div>
                            <div>
                                <span className='circle-label'>가동</span>
                                <div className={`circle ${(Number(value) >= Number(row?.operate ?? 0)) ? "operate-on" : "operate-off"}`}>
                                    {value >= row.operate ?? 0 ? "On" : "Off"}
                                </div>
                            </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export const renderExpandedRow = (row) => (
    <ExpandedRow row={row} />
);